import React, { createContext, useState, useContext, useCallback } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";

const AlertContext = createContext();

export function AlertProvider({ children }) {
  const [alertState, setAlertState] = useState({
    message: "",
    severity: "error",
    open: false,
  });

  const showAlert = useCallback((message, severity = "error") => {
    setAlertState({ message, severity, open: true });
    setTimeout(() => setAlertState((as) => ({ ...as, open: false })), 3000);
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}

      {alertState.open && (
        <Box
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            width: "400px",
            textAlign: "center",
            zIndex: 9999,
          }}
        >
          {/* Caixa do alerta centralizada */}
          <Box sx={{ width: "90%", maxWidth: 400 }}>
            <Alert
              variant="filled"
              severity={alertState.severity}
              icon={false}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                fontSize: "15px",
                "& .MuiAlert-message": {
                  width: "100%",
                  textAlign: "center",
                },
              }}
            >
              {alertState.message}
            </Alert>
          </Box>
        </Box>
      )}
    </AlertContext.Provider>
  );
}

export function useAlert() {
  return useContext(AlertContext);
}
